import { render, staticRenderFns } from "./UpdateSidebar.vue?vue&type=template&id=c32f9880&scoped=true&"
import script from "./UpdateSidebar.vue?vue&type=script&lang=ts&"
export * from "./UpdateSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateSidebar.vue?vue&type=style&index=0&id=c32f9880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32f9880",
  null
  
)

export default component.exports